import React, { forwardRef, useImperativeHandle } from 'react';
import {
  Canvas,
  LinearGradient,
  vec,
  Fill,
  Size,
} from '@shopify/react-native-skia';
import {
  useDerivedValue,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';

import { InteractiveForwardRefProps } from '@/components/interactive';

const getRandomColor = () => {
  return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
};

const initialLeftColor = 'red';
const initialRightColor = 'blue';

type AnimatedGradientProps = {
  animated?: boolean;
};

export const AnimatedGradient = forwardRef<
  InteractiveForwardRefProps,
  AnimatedGradientProps
>(({ animated = true }, ref) => {
  const leftColor = useSharedValue(initialLeftColor);
  const rightColor = useSharedValue(initialRightColor);

  const canvasSize = useSharedValue<Size>({ width: 0, height: 0 });
  const end = useDerivedValue(() => {
    return vec(canvasSize.value.width, canvasSize.value.height);
  });

  const onReset = () => {
    leftColor.value = initialLeftColor;
    rightColor.value = initialRightColor;
  };
  const onPlay = () => {
    const duration = animated ? 250 : 0;
    leftColor.value = withTiming(getRandomColor(), {
      duration,
    });
    rightColor.value = withTiming(getRandomColor(), {
      duration,
    });
  };

  useImperativeHandle(ref, () => ({
    play: onPlay,
    reset: onReset,
    pause: () => {}, // No pause functionality for this component
  }));

  const colors = useDerivedValue(() => {
    return [leftColor.value, rightColor.value];
  }, []);

  return (
    <Canvas style={{ flex: 1 }} onSize={canvasSize}>
      <Fill color="red">
        <LinearGradient start={vec(0, 0)} end={end} colors={colors} />
      </Fill>
    </Canvas>
  );
});
